import React from "react";
import "./bonus-menu.scss";
import { useTranslation } from "react-i18next";
import CusButton from "../../../mui/custom_button/CusButton";
import imgPresent from "./present.png";
import useNavigateWithSearch from "../../../../hooks/useNavigateWitchSearch";
import useDynamicImages from "../../../../hooks/useDynamicImages.js";
import { setOpenMenu } from "../../../../store/siteSlice.js";
import { useDispatch } from "react-redux";
import { ENUM_COMMON_EVENT } from "../../../../hooks/common/useListener.js";
import { dispatchCusEvent } from "../../../../utils/utils.js";

export default function BonusBannerMenu() {
  const { t } = useTranslation();
  const navigate = useNavigateWithSearch("/");

  const dispatch = useDispatch();
  const { imgBonusMenu } = useDynamicImages();

  const onGo = () => {
    navigate("/promotions");
    dispatch(setOpenMenu(false));
    dispatchCusEvent(ENUM_COMMON_EVENT.getBonus);
  };

  return imgBonusMenu ? (
    <div className="bonus-menu__img__container">
      <img className="bonus-menu__img" src={imgBonusMenu} onClick={onGo} />
    </div>
  ) : (
    <div className="bonus-menu">
      <h2>{t("Play casino games and get bonuses!")}</h2>
      <CusButton color="custom" text={"Bonuses"} onClick={onGo} />
      <img src={imgPresent} />
      <div className="bonus-menu__gradient" />
    </div>
  );
}
